import { TQueries, TStorage } from '@src/models/common';
import { getStorageUrl } from '@src/utils/storageUrl';
import { CSSProperties } from 'react';
import { TAvatarSize } from '@src/atoms/Avatar/models';
import { isObject } from 'lodash';

export const removeSpaces = (str: string) => {
  if (typeof str === 'string') {
    return str.split(' ').join('');
  }

  return str;
};

export const getAlt = (firstName?: string, lastName?: string) => {
  let alt = '';

  if (firstName) {
    alt = alt + removeSpaces(firstName);
  }

  if (lastName) {
    alt = alt + ' ' + removeSpaces(lastName);
  }

  return alt;
};

export const getUrl = ({
  storage,
  imageUrl,
}: {
  imageUrl?: string | { [key: string]: unknown };
  storage?: TStorage;
}) => {
  if (!imageUrl) return '';

  if (isObject(imageUrl)) {
    return imageUrl.mainUrl as string;
  }

  return storage ? getStorageUrl(storage, imageUrl) : imageUrl;
};

const getAvatarSize = (size: number): CSSProperties => ({
  minHeight: size,
  minWidth: size,
  height: size,
  width: size,
  // бывает вывод инициалов (две буквы)
  fontSize: size / 2.8,
});

export const getAdaptiveAvatarSize = (size: TAvatarSize, br: keyof TQueries | undefined): CSSProperties | undefined => {
  return typeof size === 'number' ? getAvatarSize(size) : br && size[br] ? getAvatarSize(size[br]) : undefined;
};
